import * as React from "react";
import { CSSProperties, useRef } from "react";
import "../../styles/base/label.scss";

export enum LabelStyle {
  PRIMARY = " primary",
  PRIMARY_NORMAL = " primary normal",
  PRIMARY_LIGHT = " primary light",
  PRIMARY_SEVERE = " primary severe",
  SECONDARY = " secondary",
  SECONDARY_NORMAL = " secondary normal",
  SECONDARY_LIGHT = " secondary light",
  SECONDARY_SEVERE = " secondary severe",
}

interface LabelProps {
  label: any;
  value?: any;
  style?: LabelStyle;
  removeAction?: (item: any) => any;
  customStyle?: CSSProperties;
}

export default function Label({ label, value, style, removeAction, customStyle }: LabelProps) {
  const closeIconRef = useRef<HTMLSpanElement>(null);

  const onRemove = (e) => {
    e.stopPropagation();
    removeAction && removeAction(value || label);
  };

  return (
    <span className={"label" + (style || "")} style={customStyle}>
      {typeof label === "object" ? label : <span>{label}</span>}
      {removeAction && (
        <i ref={closeIconRef} className="ic_close clickable action" onClick={onRemove} />
      )}
    </span>
  );
}
